<!-- <div id="preloader" *ngIf="isLoading">
  <div id="status">&nbsp;</div>
</div> -->

<!-- <div *ngIf="isLoading" class="spinner"></div> -->

<div *ngIf="isLoading" class="spinner"></div>